import { useState, useCallback, useEffect } from 'react';
import { useAuth } from './useAuth';

const AD_FREQUENCY_MIN = 2;
const AD_FREQUENCY_MAX = 4;
const AD_SESSION_KEY = 'wikisprint_ad_counter';

interface UseAdsReturn {
  shouldShowAd: boolean;
  isEligibleForAds: boolean;
  incrementMatchCount: () => void;
  resetAdCounter: () => void;
}

export function useAds(): UseAdsReturn {
  const { profile, entitlement } = useAuth();
  const [matchCount, setMatchCount] = useState<number>(() => {
    const stored = sessionStorage.getItem(AD_SESSION_KEY);
    return stored ? parseInt(stored, 10) : 0;
  });
  const [nextAdThreshold, setNextAdThreshold] = useState<number>(() => {
    return getRandomThreshold();
  });

  // Check if user is eligible for ads
  const isEligibleForAds = !profile?.is_verified && !entitlement?.remove_ads;

  // Calculate if ad should be shown
  const shouldShowAd = isEligibleForAds && matchCount >= nextAdThreshold;

  function getRandomThreshold(): number {
    return Math.floor(Math.random() * (AD_FREQUENCY_MAX - AD_FREQUENCY_MIN + 1)) + AD_FREQUENCY_MIN;
  }

  const incrementMatchCount = useCallback(() => {
    setMatchCount(prev => {
      const newCount = prev + 1;
      sessionStorage.setItem(AD_SESSION_KEY, newCount.toString());
      return newCount;
    });
  }, []);

  const resetAdCounter = useCallback(() => {
    setMatchCount(0);
    setNextAdThreshold(getRandomThreshold());
    sessionStorage.setItem(AD_SESSION_KEY, '0');
  }, []);

  // Reset threshold after showing ad
  useEffect(() => {
    if (shouldShowAd) {
      // Will reset on next match start
    }
  }, [shouldShowAd]);

  return {
    shouldShowAd,
    isEligibleForAds,
    incrementMatchCount,
    resetAdCounter,
  };
}
